import { useEffect, useState } from 'react';

export default function useScrollPosition() {
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    function handleScroll() {
        const position = window.scrollY;
        setScrollPosition(position);
    }

    return scrollPosition;
}
